import { type PaymentImageData } from "./logos/base";
import { imageData as mobilePayLogoData } from "./logos/mobile-pay-logo";
import { imageData as mobilePayIconData } from "./logos/mobile-pay-icon";
import { imageData as viabillLogoData } from "./logos/viabill-logo";
import { imageData as visaLogoData } from "./logos/visa";
import { imageData as mastercardLogoData } from "./logos/mastercard";
import { imageData as dankortLogoData } from "./logos/dankort";
import {
    type PaymentMethodKey,
    type PaymentLogoKey,
    type PaymentMethod,
} from "./payment-method";

//import { default as viabillLogoSize } from "size.js!=!odendo-image-size-loader?module!../shop-checkout/payment-methods/viabill.png";

export function getViaBillLogo() {
    return viabillLogoData;
}

export function getImageUrls(
    paymentMethod: PaymentMethod
): PaymentImageData[][] {
    if (paymentMethod.guid === 15) return [viabillLogoData];
    if (paymentMethod.guid === 21) return [mobilePayLogoData];
    if (paymentMethod.guid === 1) {
        if (paymentMethod.logos != null) {
            return getCardPaymentLogos(paymentMethod.logos).map((x) => x.data);
        }
        //return [visaLogo, mastercardLogo, dankortLogo];
    }
    return imagesFromHtml(paymentMethod.name).map((x) => [
        {
            url: x,
            width: 32,
            height: 32,
        },
    ]);
}

interface ImageAndSize {
    data: PaymentImageData[];
}

export function getPaymentMethodLogos(
    keys: (PaymentLogoKey | PaymentMethodKey)[]
) {
    const result: ({
        key: PaymentLogoKey | PaymentMethodKey;
        icon?: ImageAndSize;
    } & ImageAndSize)[] = [];
    if (keys.includes("MobilePay")) {
        result.push({
            data: mobilePayLogoData,
            key: "MobilePay",
            icon: {
                data: mobilePayIconData,
            },
        });
    }
    for (const cardPaymentLogo of getCardPaymentLogos(keys)) {
        result.push(cardPaymentLogo);
    }
    return result;
}

export type CardPaymentLogo = ReturnType<typeof getPaymentMethodLogos>[number];

export function getCardPaymentLogos(logos: (PaymentLogoKey | string)[]) {
    const result: {
        data: PaymentImageData[];
        key: PaymentLogoKey;
    }[] = [];
    if (logos.includes("visa")) {
        result.push({
            data: visaLogoData,
            key: "visa",
        });
    }
    if (logos.includes("mastercard")) {
        result.push({
            data: mastercardLogoData,
            key: "mastercard",
        });
    }
    if (logos.includes("dankort")) {
        result.push({
            data: dankortLogoData,
            key: "dankort",
        });
    }
    return result;
}

function imagesFromHtml(text: string): string[] {
    const container = document.createElement("div");
    container.innerHTML = text;
    return Array.from(container.querySelectorAll("img"))
        .map((x) => x.getAttribute("src"))
        .filter((x) => x != null) as string[];
}
